const isCNServer = () => SERVER_LOCATION === 'cn';

const isRuServer = () => SERVER_LOCATION === 'ru';

const isJapan = () => SERVER_LOCATION === 'jp';

const isAzServer = () => SERVER_LOCATION === 'az';

export { isCNServer, isRuServer, isJapan, isAzServer };